module.exports = __webpack_public_path__ + "static/instalaciones-1-ee5f0d3e578214e71c6e6a0b1dc85e50.jpg";